import * as React from "react";
import { cn } from "@/lib/utils";

import {
  HeadCell,
  Row,
  Table,
  TableCell,
  TableHead,
  TBody,
} from "ui/simple-table";
import { Checkbox } from "@/components/ui/checkbox";
import { SmallMediaFilePreview } from "../small-media-file-preview";
import { CollectionFile } from "../../../../shared/types/files";

type CellComponent = React.ComponentType<React.PropsWithChildren>;

interface Props {
  files: CollectionFile[];
  renderHeader(HeadCell: CellComponent): React.ReactNode;
  renderFile(file: CollectionFile, Cell: CellComponent): React.ReactNode;
  isFileSelected(file: CollectionFile): boolean;
  onSelect(file: CollectionFile): void;
  onRemove(file: CollectionFile): void;
}

export function SelectableFilesTable(props: Props) {
  return (
    <Table>
      <TableHead>
        <HeadCell />
        <HeadCell />
        {props.renderHeader(HeadCell)}
      </TableHead>
      <TBody>
        {props.files.map((file) => {
          const isFileSelected = props.isFileSelected(file);

          function handleClick() {
            if (isFileSelected) {
              props.onRemove(file);
            } else {
              props.onSelect(file);
            }
          }

          return (
            <Row
              key={file._id}
              className={cn(
                "cursor-pointer transition-colors",
                isFileSelected && "bg-blue-50"
              )}
              onClick={handleClick}
            >
              <TableCell css="width: 20px">
                <span onClick={(e) => e.stopPropagation()}>
                  <Checkbox
                    checked={isFileSelected}
                    onCheckedChange={handleClick}
                  />
                </span>
              </TableCell>
              <TableCell css="width: 55px">
                <SmallMediaFilePreview
                  src={file.thumbnail}
                  isVideo={file.meta.isVideo}
                  className="w-[55px] h-[55px]"
                />
              </TableCell>
              {props.renderFile(file, TableCell)}
            </Row>
          );
        })}
      </TBody>
    </Table>
  );
}
